<template>
  <div class="column is-one-third">
    <div class="box">
      <header class="box-header">
        <a
          class="icon-button trash is-pulled-right"
          @click.prevent="showDeleteModal = true"
        />
        <router-link
          :to="{ name: 'collection-detail', params: { collectionId: collection.pk, collectionObj: collection }}"
        >
          <p class="text label-large header-title">
            {{ collection.name }}
          </p>
          <span class="text medium color-bluegrey3">{{ collection.item_count }} items</span>
        </router-link>
      </header>
      <div class="box-content">
        <div class="content">
          {{ collection.description }}
          <div v-if="collection.items.length > 0">
            <div
              v-for="item in collection.items"
              :key="collection.pk + item.pk"
              class="columns is-vcentered mini-track is-mobile"
            >
              <div
                v-if="item.cover_thumbnail"
                class="column cover is-narrow"
              >
                <img :src="item.cover_thumbnail">
              </div>
              <div class="column">
                <p class="text label-small color-bluegrey1 track-title">
                  {{ item.display_title }}
                </p>
                <p class="text small color-bluegrey3 track-artist">
                  {{ item.artist.name }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer class="box-footer">
        <p>
          <router-link
            :to="{ name: 'collection-detail', params: { collectionId: collection.pk }}"
            class="button is-secondary is-small"
          >
            View all items
          </router-link>
        </p>
      </footer>
    </div>
    <b-modal :active.sync="showDeleteModal">
      <div
        class="modal-card"
        style="width: auto"
      >
        <header class="modal-card-head">
          <p class="modal-card-title">
            Delete {{ collection.name }}?
          </p>
        </header>
        <section class="modal-card-body">
          <p>Are you sure you want to delete the collection {{ collection.name }}?</p>
        </section>
        <footer class="modal-card-foot">
          <button
            class="button is-block is-secondary"
            @click.prevent="showDeleteModal = false"
          >
            Close
          </button>
          <button
            class="button is-block is-danger"
            @click.prevent="handleDelete"
          >
            Yes
          </button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'CollectionListItem',

  props: {
    collection: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      showDeleteModal: false
    }
  },

  methods: {
    handleDelete: function () {
      this.$store.dispatch('collections/performDelete', this.collection.pk)
    }
  }
}
</script>

<style lang="scss">
.box-content {
  height: 208px;
}
</style>
